export const ActionType = Object.freeze({
  DELETE: "DELETE",
  APPROVAL_REQUEST: "APPROVAL_REQUEST",
  REJECT: "REJECT",
  REJECT_DEL: "REJECT_DEL",
  APPROVAL: "APPROVAL",
  DEL_REQUEST: "DEL_REQUEST",
  UPDATE: "UPDATE",
  SAVE: "SAVE",
  FEEDBACK_CONFIRM: "FEEDBACK_CONFIRM",
  CATEGORY_ADDITION: "CATEGORY_ADDITION",
  UPDATE_ORDERING: "UPDATE_ORDERING",
  EXPORT_ALL_USER: "EXPORT_ALL_USER",
  EXPORT_ALLOW_MARKETING_USER: "EXPORT_ALLOW_MARKETING_USER",
  POPUP_CENTER_ADD: "POPUP_CENTER_ADD",
  POPUP_CENTER_MODIFY: "POPUP_CENTER_MODIFY",
  POPUP_CENTER_REMOVE: "POPUP_CENTER_REMOVE",
  POPUP_BOTTOM_ADD: "POPUP_BOTTOM_ADD",
  POPUP_BOTTOM_MODIFY: "POPUP_BOTTOM_MODIFY",
  POPUP_BOTTOM_REMOVE: "POPUP_BOTTOM_REMOVE",
  POPUP_ASSET_ADD: "POPUP_ASSET_ADD",
  POPUP_ASSET_MODIFY: "POPUP_ASSET_MODIFY",
  POPUP_ASSET_REMOVE: "POPUP_ASSET_REMOVE"
});

export type ACTION_TYPE = keyof typeof ActionType;

export const getActionTypeLangKey = (value: string) => {
  switch (value) {
    case ActionType.DELETE:
      return 'I18N_ACTION_TYPE_DELETE';
    case ActionType.APPROVAL_REQUEST:
      return 'I18N_ACTION_TYPE_APPROVAL_REQUEST';
    case ActionType.REJECT:
      return 'I18N_ACTION_TYPE_REJECT';
    case ActionType.REJECT_DEL:
      return 'I18N_ACTION_TYPE_REJECT_DEL';
    case ActionType.APPROVAL:
      return 'I18N_ACTION_TYPE_APPROVAL';
    case ActionType.DEL_REQUEST:
      return 'I18N_ACTION_TYPE_DEL_REQUEST';
    case ActionType.UPDATE:
      return 'I18N_ACTION_TYPE_UPDATE';
    case ActionType.SAVE:
      return 'I18N_ACTION_TYPE_SAVE';
    case ActionType.FEEDBACK_CONFIRM:
      return 'I18N_ACTION_TYPE_FEEDBACK_CONFIRM';
    case ActionType.CATEGORY_ADDITION:
      return 'I18N_ACTION_TYPE_CATEGORY_ADDITION';
    case ActionType.UPDATE_ORDERING:
      return 'I18N_ACTION_TYPE_UPDATE_ORDERING';
    case ActionType.EXPORT_ALL_USER:
      return 'I18N_ACTION_TYPE_EXPORT_ALL_USER';
    case ActionType.EXPORT_ALLOW_MARKETING_USER:
      return 'I18N_ACTION_TYPE_EXPORT_ALLOW_MARKETING_USER';
    case ActionType.POPUP_CENTER_ADD:
      return 'I18N_ACTION_TYPE_POPUP_CENTER_ADD';
    case ActionType.POPUP_CENTER_MODIFY:
      return 'I18N_ACTION_TYPE_POPUP_CENTER_MODIFY';
    case ActionType.POPUP_CENTER_REMOVE:
      return 'I18N_ACTION_TYPE_POPUP_CENTER_REMOVE';
    case ActionType.POPUP_BOTTOM_ADD:
      return 'I18N_ACTION_TYPE_POPUP_BOTTOM_ADD';
    case ActionType.POPUP_BOTTOM_MODIFY:
      return 'I18N_ACTION_TYPE_POPUP_BOTTOM_MODIFY';
    case ActionType.POPUP_BOTTOM_REMOVE:
      return 'I18N_ACTION_TYPE_POPUP_BOTTOM_REMOVE';
    case ActionType.POPUP_ASSET_ADD:
      return 'I18N_ACTION_TYPE_POPUP_ASSET_ADD';
    case ActionType.POPUP_ASSET_MODIFY:
      return 'I18N_ACTION_TYPE_POPUP_ASSET_MODIFY';
    case ActionType.POPUP_ASSET_REMOVE:
      return 'I18N_ACTION_TYPE_POPUP_ASSET_REMOVE';
    default:
      return '';
  }
};

